import cn from 'classnames';
import { CONTACT_CASH_KEY, useSendContactFormMutation } from 'redux/apis/dataSending';
import styles from './styles.module.scss';

export const FormAlert = () => {
  const [_, { isSuccess }] = useSendContactFormMutation({ fixedCacheKey: CONTACT_CASH_KEY });

  return (
    <div className={cn(styles['form-alert'], { [styles.onSuccess]: isSuccess })}>
      <h4>
        🙌 Thanks!
      </h4>

      <p>
        We have received your request. We will back in a flash ⚡
      </p>
    </div>
  );
};
